module.exports = __webpack_public_path__ + "img/T2A_rc_5.423a5f9e.png";